import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { AuthLayout, PageSpinner, TextLink } from '../components/ui';
import { returnPath, withNext } from '../lib/auth-client';
import { useSession } from '../lib/session';

/**
 * Where the emailed link lands. The API has already checked the token and signed the
 * person in; it adds `?error=` when the link was expired or already used.
 */
export function VerifyEmail() {
  const [params] = useSearchParams();
  const { me, refresh } = useSession();
  const navigate = useNavigate();
  const failed = params.has('error');
  const back = returnPath(params.get('next'));

  useEffect(() => {
    if (!failed) void refresh();
  }, [failed, refresh]);

  useEffect(() => {
    if (!failed && me)
      navigate(
        me.profileComplete ? (back ?? '/account?welcome=1') : withNext('/complete-profile', back),
        { replace: true },
      );
  }, [failed, me, navigate, back]);

  if (failed) {
    return (
      <AuthLayout title="This link didn’t work">
        <p className="text-ink">
          It may have expired (links work for 24 hours) or been used already.{' '}
          <TextLink to={withNext('/sign-in', back)}>Sign in</TextLink> and we’ll send you a new one.
        </p>
      </AuthLayout>
    );
  }

  if (me === null) {
    return (
      <AuthLayout title="Email confirmed">
        <p className="text-ink">
          You’re all set. <TextLink to={withNext('/sign-in', back)}>Sign in</TextLink> to continue.
        </p>
      </AuthLayout>
    );
  }

  return <PageSpinner />;
}
